import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import logardo from "./logos/logo-vivamosVL.svg";


export default function ButtonAppBar() {

  const irAtras = {

  }

  return (
    <Box sx={{ flexGrow: 1 }} >
      <AppBar position="static"
      color='inherit'>
        <Toolbar className="app-bar">
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            href="/nuevaturnera"
          >
            <ArrowBackIcon visibility="hidden" />
          </IconButton> */}

          <ArrowBackIcon visibility="hidden" />
          <img src={logardo} style={{height: "62px"}} />
          <ArrowBackIcon visibility="hidden" />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
